import { Injectable } from '@angular/core';
import { ConsoleTelemetryProvider } from './providers/console.telemetry-provider';
import { merge } from 'lodash-es';
import { GeneratorUtility } from '../generator.utility';
import { CloudwatchTelemetryProvider } from './providers/cloudwatch.telemetry-provider';
import { TelemetryContext } from './models/telemetry-context';
import { TelemetryErrorEvent } from './models/telemetry-error-event';
import { TelemetryPageViewEvent } from './models/telemetry-page-view-event';
import { TelemetryEvent } from './models/telemetry-event';
import { BrowserDataUtility } from '../browser-data.utility';
import { AppConfigService } from '../../services/app-config.service';

@Injectable({
	providedIn: 'root'
})
export class InsightsUtility {
	public get context(): TelemetryContext {
		return this._context;
	}

	private _context: TelemetryContext = {};

	constructor(
		private consoleTelemetryProvider: ConsoleTelemetryProvider,
		private cloudwatchTelemetryProvider: CloudwatchTelemetryProvider,
		private browserDataUtility: BrowserDataUtility,
		private config: AppConfigService
	) {
		this._context.telemetryUserId = this.getUserId();
		this._context.telemetrySessionId = this.getSessionId();

		const browserData = this.browserDataUtility.getBrowserData();
		this._context.browser = browserData?.browser;
		this._context.device = browserData?.device;
		this._context.operatingSystem = browserData?.operatingSystem;
	}

	public event(event: TelemetryEvent): void {
		event = this.applyContext(event);
		const environment = this.config.getConfig().environment;

		if (event instanceof TelemetryErrorEvent) {
			this.cloudwatchTelemetryProvider.trackError(event);
			if (environment === 'development') {
				this.consoleTelemetryProvider.trackError(event);
			}
		} else if (event instanceof TelemetryPageViewEvent) {
			this.cloudwatchTelemetryProvider.trackPageView(event);
			if (environment === 'development') {
				this.consoleTelemetryProvider.trackPageView(event);
			}
		} else if (event instanceof TelemetryEvent) {
			this.cloudwatchTelemetryProvider.trackEvent(event);
			if (environment === 'development') {
				this.consoleTelemetryProvider.trackEvent(event);
			}
		}
	}

	public updateTelemetryContext(context: TelemetryContext): void {
		merge(this._context, context);
	}

	private applyContext(event: TelemetryEvent): TelemetryEvent {
		this._context.telemetryHref = window.location.href;
		if (!event.context) {
			event.context = {};
		}
		merge(event.context, this._context);
		return event;
	}

	private getSessionId(): string {
		let id = sessionStorage.getItem('lexbe-telemetry-session-id');

		if (!id) {
			id = GeneratorUtility.generateId();
			sessionStorage.setItem('lexbe-telemetry-session-id', id);
		}

		return id;
	}

	private getUserId(): string {
		let id = localStorage.getItem('lexbe-telemetry-user-id');

		if (!id) {
			id = GeneratorUtility.generateId();
			localStorage.setItem('lexbe-telemetry-user-id', id);
		}

		return id;
	}
}


